import type { GameState } from './model.ts'

function stableSerialize(value: unknown): string {
  if (value === null) {
    return 'null'
  }
  if (typeof value === 'string' || typeof value === 'boolean') {
    return JSON.stringify(value)
  }
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) {
      throw new TypeError('Canonical state cannot contain a non-finite number.')
    }
    return JSON.stringify(value)
  }
  if (Array.isArray(value)) {
    return '[' + value.map((item) => stableSerialize(item)).join(',') + ']'
  }
  if (typeof value === 'object') {
    const record = value as Record<string, unknown>
    const entries = Object.keys(record)
      .sort()
      .map(
        (key) =>
          JSON.stringify(key) + ':' + stableSerialize(record[key]),
      )
    return '{' + entries.join(',') + '}'
  }

  throw new TypeError('Canonical state contains an unsupported value.')
}

export function canonicalStateJson(state: GameState): string {
  return stableSerialize(state)
}

export function canonicalStateDigest(state: GameState): string {
  const canonical = canonicalStateJson(state)
  let hash = 0x811c9dc5

  for (let index = 0; index < canonical.length; index += 1) {
    hash ^= canonical.charCodeAt(index)
    hash = Math.imul(hash, 0x01000193)
  }

  return 'metaphorge-v1-' + (hash >>> 0).toString(16).padStart(8, '0')
}
